import React from 'react';

const DaySquare = ({ day, highlightValue }) => {
  return (
    <div className={`day-square ${highlightValue ? 'has-event' : ''}`}>
      <span className="day-number">{day}</span>
      {highlightValue && (
        <div className="highlight-value">
          {highlightValue}
        </div>
      )}
    </div>
  );
};

export default DaySquare;
